export default "__VITE_ASSET__Dun2VInn__"